module.exports = __webpack_public_path__ + "static/media/newShell.a222d875.svg";